export default {
    // Traductions générales du compte utilisateur
    'User account': 'Compte utilisateur',
    
    // Traductions pour vconsole.elements.base.html
    'EDIT PASSWORD': 'MODIFIER LE MOT DE PASSE',
    'DELETE ACCOUNT': 'SUPPRIMER LE COMPTE',
    
    // Traductions pour UserStorageDisplay.vue
    'Storage plan': 'Plan de stockage',
    'Free': 'Gratuit',
    'credits/month': 'crédits/mois',
    'Terms & Pricing': 'Conditions & Tarifs',
    
    // Traductions pour vconsole.edit-password.html
    'Edit your password': 'Modifier votre mot de passe',
    'Current password': 'Mot de passe actuel',
    'New password': 'Nouveau mot de passe',
    'Confirm password': 'Confirmer le mot de passe',
    'The password must be at least {min} characters long': 'Le mot de passe doit contenir au moins {min} caractères',
    'The passwords cannot be empty': 'Les mots de passe ne peuvent être vides',
    'The passwords do not match': 'Les mots de passe ne correspondent pas',
    'Cancel': 'Annuler',
    'Ok': 'Valider',
    
    // Traductions pour les messages de notification
    'Your password has been modified': 'Votre mot de passe a été modifié',
    'Your account has been disabled.': 'Votre compte a été désactivé.',
    'Thank you for having used Vodalys.': 'Merci d\'avoir utilisé Vodalys.',
    'Close': 'Fermer',
    
    // Traductions pour le modal de confirmation de suppression
    'You are about to delete your account.': 'Vous êtes sur le point de supprimer votre compte.',
    'Confirm': 'Confirmer'
}